/* eslint @typescript-eslint/no-explicit-any: 0 */

import { connectStateResults } from 'react-instantsearch-dom';

import type {
  RefinedResultsItemProps,
  RefinedResultsProps,
  SearchPanelRefinedResultsProps
} from '~/legacy/types';

import IfHits from './IfHits';
import { Index } from './InstantSearch';
import { searchTypes } from './SearchPanelResultsTypes';

const RefinedResults = connectStateResults(
  ({
    searchResults,
    type,
    label,
    currentDisplay,
    displayType
  }: RefinedResultsProps) =>
    searchResults && (
      <li
        style={{ fontWeight: type === currentDisplay ? 'bold' : '300' }}
        className="text-title-sm mr-5 cursor-pointer inline-block"
        onClick={() => {
          displayType(type);
        }}
      >
        {label}
      </li>
    )
);

export const RefinedResultsItem = ({
  indexId,
  label,
  type,
  setDisplayState,
  displayState,
  searchCondition
}: RefinedResultsItemProps) => {
  const indexObject = {
    Root: ({ children }: { children: any }) => children,
    props: {}
  };

  return (
    <Index indexId={indexId} root={indexObject}>
      <IfHits condition={searchCondition}>
        <RefinedResults
          label={label}
          type={type}
          displayType={setDisplayState}
          currentDisplay={displayState}
        />
      </IfHits>
    </Index>
  );
};

const SearchPanelRefinedResults = ({
  displayState,
  setDisplayState,
  searchCondition,
  redirectLinks,
  searchOptions
}: SearchPanelRefinedResultsProps) => {
  const items = searchTypes({ redirectLinks, searchOptions });

  return (
    <>
      {items.map((item: any = {}) => {
        const { indexId, label, type } = item;

        return (
          <RefinedResultsItem
            key={type}
            indexId={indexId}
            label={label}
            type={type}
            displayState={displayState}
            setDisplayState={setDisplayState}
            searchCondition={searchCondition}
          />
        );
      })}
    </>
  );
};

export default SearchPanelRefinedResults;
